var map = {
	"./slackEmoji0.gif": 34,
	"./slackEmoji1.gif": 35,
	"./slackEmoji2.gif": 36,
	"./slackEmoji3.gif": 37,
	"./slackEmoji4.gif": 38,
	"./slackEmoji5.gif": 39,
	"./slackEmoji6.gif": 40,
	"./slackEmoji7.gif": 41,
	"./slackEmoji8.gif": 42,
	"./slackEmoji9.gif": 43
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/slackEmoji.*\.gif$
// module id = 33
// module chunks = 0